var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_vm._l((_vm.items),function(item){return [_c('v-col',{key:item.uuid,attrs:{"md":"6","sm":"6","cols":"3"}},[_c('ItemGridItem',{attrs:{"item":item}})],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }